import { Box, Skeleton } from "@mui/material";
import useLanguages from "../../../../../explorer/hooks/useLanguages";
import { BasketItem } from "../../../../../explorer/types/Basket/BasketItems";
import { WarrantyItem } from "../../../../types";

type TPriceFormatComponent = {
    item: BasketItem | WarrantyItem;
    additionalProps?: any;
    colName: string;
};

const PriceFormatComponent = (props: TPriceFormatComponent) => {
    const lang = useLanguages().currentLanguage;
    const { item, additionalProps, colName } = props;
    const price = (
        item as {
            [key: string]: any;
        }
    )[colName];

    return (
        <Box>
            {additionalProps?.loadingPrices ||
            additionalProps?.listDisabledRow.current.includes(item.rowId) ? (
                <Skeleton />
            ) : item.hidePrice ||
              Number(price) === 0 ||
              isNaN(Number(price)) ? (
                "-"
            ) : (
                Intl.NumberFormat(lang, {
                    style: "currency",
                    currency: item.currency ?? "EUR",
                }).format(Number(price))
            )}
        </Box>
    );
};

export default PriceFormatComponent;
